// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z97uN","question":"styles_question___tlKE","description":"styles_description__jI712"};